import { Component } from '@angular/core';
import { FinanceDisbursementRequestType } from '@max/finance/models/enums/finance-disbursement-request-type.enum';
import { BaseComponent } from '../../../shared/base-components/base.component';
import { DisbursementSummarySearchCriteriaModel } from '../../models/disbursement/disbursement-summary-search-criteria.model';
import { DisbursementSummarySearchResultsModel } from '../../models/disbursement/disbursement-summary-search-results.model';
import { DisbursementSummaryModel } from '../../models/disbursement/disbursement-summary.model';
import { DisbursementService } from '../../services/disbursement.service';

@Component({
    selector: 'disbursement-summary',
    templateUrl: './disbursement-summary.html',
    inputs: ['disbursementSummary', 'financeDisbursementRequestId'],
})

export class DisbursementSummaryComponent extends BaseComponent {
    public disbursementSummary: DisbursementSummaryModel;
    public financeDisbursementRequestId: number;
    public fuelTaxDisbursement = false;
    public loading = true;
    public financeDisbursementRequestType: FinanceDisbursementRequestType = new FinanceDisbursementRequestType();

    constructor(private disbursementService: DisbursementService) {
        super();
    }

    public ngOnInit() {
        if (!this.disbursementSummary) {
            if (!this.financeDisbursementRequestId) {
                return;
            }

            const searchCriteria = new DisbursementSummarySearchCriteriaModel(null);
            searchCriteria.financeDisbursementRequestId = this.financeDisbursementRequestId;
            searchCriteria.startDate = new Date(2000, 0, 1);
            searchCriteria.endDate = new Date(4000, 0, 1); // dates are required for search even though requesting by ID.

            this.disbursementService.searchDisbursements(searchCriteria).subscribe(
                data => {
                    const results = new DisbursementSummarySearchResultsModel(data);
                    if (results && results.disbursementSummaries && results.disbursementSummaries.length > 0) {
                        this.disbursementSummary = results.disbursementSummaries[0];
                        this.fuelTaxDisbursement = this.getFuelTaxDisbursement(this.disbursementSummary, this.financeDisbursementRequestType);
                    }
                    this.loading = false;
                },
                error => {
                    this.handleValidationResult(error);
                    this.loading = false;
                }
            );
        } else {
            this.loading = false;
        }
    }

    /**
     * Checks whether the disbursement is for fuel taxes
     * @param disbursementSummary the model which represents the disbursement
     * @param financeDisbursementRequestType an enum for different types of disbursements
     * @returns a boolean indicating whether the disbursement is for fuel taxes
     **/
    private getFuelTaxDisbursement(disbursementSummary: DisbursementSummaryModel, financeDisbursementRequestType: FinanceDisbursementRequestType): boolean {
        const financeDisbursementRequestTypeId = disbursementSummary.financeDisbursementRequestTypeId;
        const fuelTaxDisbursement = !!financeDisbursementRequestTypeId
            && financeDisbursementRequestTypeId != financeDisbursementRequestType.CheckDisbursement.id
            && financeDisbursementRequestTypeId != financeDisbursementRequestType.DigitalDisbursement.id;

        return fuelTaxDisbursement;
    }
}
